import {LeadModel, SuperBit_swaggerClient,LeadFilterModel, PolicyFilterModel} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

export class LeadsModel {
    client:any;
    constructor() {
        this.init();
    }

    async init () {
        let apiUrl = localStorage.getItem('apiUrl');
        if (!apiUrl) {
            apiUrl = await this.fetchData();
        }
        var url = apiUrl ? apiUrl : generalSettings.apiUrl;
        //var url = "https://localhost:44333";
        //this.client = new SuperBit_swaggerClient("http://api.dev-alt.superbit.co.il");
        this.client = new SuperBit_swaggerClient(url);//(settings.apiUrl);
    }
    

    async fetchData () {
        let apiUrl = undefined;
        try {
            const response = await fetch('/config.json');
            const jsonData = await response.json();
            apiUrl = jsonData.apiUrl;
            localStorage.setItem('apiUrl', apiUrl)
            localStorage.setItem('appConfig', JSON.stringify(jsonData));
        } catch (error) {
            console.error('Error fetching data: ', error);
        }
        return apiUrl;
    };

    
    async leadsIndex(){
        return this.client.leadsIndex({});
        // leadsFilter(body)
    }

    async filter(body: LeadFilterModel | undefined){
        if (body) {
            Object.keys(body).forEach((key: any) => {
                // if (typeof((body as any)[key]) == 'object') {
                //     console.log('filter', key, typeof((body as any)[key]), (body as any)[key]);
                // }
                switch (key) {
                    case 'createDateFrom':
                    case 'createDateTo':
                    case 'closeDateFrom':
                    case 'closeDateTo':
                    case 'deliveryDateFrom':
                    case 'deliveryDateTo':
                        if(typeof((body as any)[key])=='object') {
                            if ((body as any)[key]) {
                                // const date: Date = (body as any)[key] as Date;
                                // const day = date.getDate();
                                // let dayString = day.toString();
                                // if (day < 10) {
                                //     dayString = `0${day}`;
                                // }
                                // const year = date.getFullYear();
                                // const month = date.getMonth()+1;
                                // let monthStr = month.toString()
                                // if (month < 10) {
                                //     monthStr = `0${month}`;
                                // }
                                // // const timeString = date.toISOString().split('T')[1];
                                // const timeString = '00:00:00';
                                
                                // const dateString = `${year}-${monthStr}-${dayString}T${timeString}`;
                                // console.log('filter', key, typeof(date), date, dateString, day, month, year);
                                (body as any)[key] = this.formatDateForLeadFilter(key, (body as any)[key]);
                            }
                        }
                        break;
                
                    default:
                        break;
                }
            })
        }
        return this.client.leadsFilter(body);
    }


    async renewalsfilter(body: LeadFilterModel | undefined){
        if (body) {
            Object.keys(body).forEach((key: any) => {
                // if (typeof((body as any)[key]) == 'object') {
                //     console.log('filter', key, typeof((body as any)[key]), (body as any)[key]);
                // }
                switch (key) {
                    case 'createDateFrom':
                    case 'createDateTo':
                    case 'closeDateFrom':
                    case 'closeDateTo':
                    case 'deliveryDateFrom':
                    case 'deliveryDateTo':
                        if(typeof((body as any)[key])=='object') {
                            if ((body as any)[key]) {
                                // const date: Date = (body as any)[key] as Date;
                                // const day = date.getDate();
                                // let dayString = day.toString();
                                // if (day < 10) {
                                //     dayString = `0${day}`;
                                // }
                                // const year = date.getFullYear();
                                // const month = date.getMonth()+1;
                                // let monthStr = month.toString()
                                // if (month < 10) {
                                //     monthStr = `0${month}`;
                                // }
                                // // const timeString = date.toISOString().split('T')[1];
                                // const timeString = '00:00:00';
                                
                                // const dateString = `${year}-${monthStr}-${dayString}T${timeString}`;
                                // console.log('filter', key, typeof(date), date, dateString, day, month, year);
                                (body as any)[key] = this.formatDateForLeadFilter(key, (body as any)[key]);
                            }
                        }
                        break;
                
                    default:
                        break;
                }
            })
        }
        return this.client.renewalsFilter(body);
    }


    async filterToExcel(body: LeadFilterModel | undefined){
        if (body) {
            Object.keys(body).forEach((key: any) => {
                // if (typeof((body as any)[key]) == 'object') {
                //     console.log('filter', key, typeof((body as any)[key]), (body as any)[key]);
                // }
                switch (key) {
                    case 'createDateFrom':
                    case 'createDateTo':
                    case 'closeDateFrom':
                    case 'closeDateTo':
                    case 'deliveryDateFrom':
                    case 'deliveryDateTo':
                        if(typeof((body as any)[key])=='object') {
                            if ((body as any)[key]) {
                                // const date: Date = (body as any)[key] as Date;
                                // const day = date.getDate();
                                // let dayString = day.toString();
                                // if (day < 10) {
                                //     dayString = `0${day}`;
                                // }
                                // const year = date.getFullYear();
                                // const month = date.getMonth()+1;
                                // let monthStr = month.toString()
                                // if (month < 10) {
                                //     monthStr = `0${month}`;
                                // }
                                // // const timeString = date.toISOString().split('T')[1];
                                // const timeString = '00:00:00';
                                
                                // const dateString = `${year}-${monthStr}-${dayString}T${timeString}`;
                                // console.log('filter', key, typeof(date), date, dateString, day, month, year);
                                (body as any)[key] = this.formatDateForLeadFilter(key, (body as any)[key]);
                            }
                        }
                        break;
                
                    default:
                        break;
                }
            })
        }

        console.log('filterToExcel', body)
        return this.client.leadsFilterToExcelExport(body);
    }

    formatDateForLeadFilter (dateType: string, dateObj: Date) {
        const date: Date = dateObj;
        const day = date.getDate();
        let dayString = day.toString();
        if (day < 10) {
            dayString = `0${day}`;
        }
        const year = date.getFullYear();
        const month = date.getMonth()+1;
        let monthStr = month.toString()
        if (month < 10) {
            monthStr = `0${month}`;
        }
        // const timeString = date.toISOString().split('T')[1];
        let timeString = '00:00:00';
        let dateString = '';
        switch (dateType) {
            case 'createDateFrom':
                dateString = `${year}-${monthStr}-${dayString}`;
                break;
            case 'closeDateFrom':
                dateString = `${year}-${monthStr}-${dayString}`;
                break;
            case 'deliveryDateFrom':
                // timeString = '00:00:00';
                dateString = `${year}-${monthStr}-${dayString}`;
                break;
            case 'closeDateTo':
                dateString = `${year}-${monthStr}-${dayString}`;
                break;
            case 'createDateTo':
                dateString = `${year}-${monthStr}-${dayString}`;
                break;
            case 'deliveryDateTo':
                // timeString = '23:59:59';
                dateString = `${year}-${monthStr}-${dayString}`;
                break;
        
            default:
                break;
        }
        
        // const dateString = `${year}-${monthStr}-${dayString}T${timeString}`;
        // dateString = `${year}-${monthStr}-${dayString}`;
        // console.log('filter', key, typeof(date), date, dateString, day, month, year);
        // (body as any)[key] = dateString;
        return dateString
    }

    async getLeadForUpsert(id:string|undefined){
        
        return this.client.leadsCreate({id: id});
        
    }

    async upsertLead(lead:LeadModel|undefined){
        // 
        console.log('Save with Additions', lead)
        return await this.client.leadsCreate2(lead);
    }

    async leadsSendMail(id: string) {
        return await this.client.leadsSendMail(id);
    }

    async sendToWhatsApp(id: string) {
        return await this.client.whatsappSendPropose(id);
    }

    async getLeadStatuses() {
        return await this.client.getLeadStatuses();
    }
    
    async getOldLeadStatuses() {
        return await this.client.getOldLeadStatuses();
    }

    async leadsDelete (leadId: string) {
        return await this.client.leadsDelete(leadId);
    }

    async checkLicenseFoDoubleLead(licenceNumber: string) {
        return this.client.getVehicleByLicenseNumber(licenceNumber)
    }

    async checkPhoneForDoubleLead(phone: string) {
        return this.client.leadsCheckPhoneForDoubleForPCStation({
            phone
        })
    }

    async createRidersForLead(offerId: string | undefined) {
        return this.client.leadsCreateRidersForLead(offerId);
    }

    async updateLeadStatus(request: any) {
        return this.client.leadUpdateStatus(request);
    }

    async policyFilter(request?: any) {
        return this.client.policyFilter(request);
    }

    async customerCardGetUsers() {
        return this.client.customerCardGetUsers();
    }

}





